import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  zoomInOnVerticalView,
  zoomOutOnVerticalView,
  zoomToLevel,
} from "../../store/timeline";
import IconButtonComponent from "../UI/buttons/IconButton";
import { ReactComponent as ZoomInIcon } from "../../assets/icons/zoom-in.svg";
import { ReactComponent as ZoomOutIcon } from "../../assets/icons/zoom-out.svg";
import zoomStyles from "../../styles/ganttChart/zoom.module.css";
import { useEffect } from "react";
import useDataSelector from "../../hooks/useDataSelector";

const ZoomComponent = () => {
  const dispatch = useAppDispatch();

  const { timelineRange, pixelPerMinute, defaultPixelPerMinute, zoomLevel } =
    useAppSelector((state) => state.timelineSlice);

  const { selectedGanttChartTab } = useAppSelector(
    (state) => state.ganttChartSlice
  );

  const dataToUse = useDataSelector();

  const handleZoomIn = () => {
    const pixelsFromTop = document.getElementById(
      "vertical-ganttChart-svg-wrapper"
    )?.scrollTop;

    dispatch(zoomInOnVerticalView(pixelsFromTop!));
  };
  const handleZoomOut = () => {
    const pixelsFromTop = document.getElementById(
      "vertical-ganttChart-svg-wrapper"
    )?.scrollTop;
    dispatch(zoomOutOnVerticalView(pixelsFromTop!));
  };

  useEffect(() => {
    dispatch(zoomToLevel(selectedGanttChartTab !== "Custom"));
  }, [defaultPixelPerMinute]);

  return (
    <>
      {timelineRange && (
        <div className={zoomStyles.zoomWrapper}>
          <IconButtonComponent
            width={20}
            disable={timelineRange!.hoursInView <= 2}
            id="zoom-in"
            icon={<ZoomInIcon width={16} />}
            onClick={handleZoomIn}
          />
          <IconButtonComponent
            width={20}
            // temporary. Will be updated on card related to change in triggering KPI bar.
            disable={pixelPerMinute === 0.66}
            id="zoom-out"
            icon={<ZoomOutIcon width={16} />}
            onClick={handleZoomOut}
          />
        </div>
      )}
    </>
  );
};

export default ZoomComponent;
